import { Theme, CSSObject } from '@mui/material/styles';

import { getThemeColor } from '@cast/design-system';

import { rankVariables } from 'constants/theme';

export const getRowRankClass = (rank?: number): string | undefined => {
  if (rank === undefined || rank < 0) {
    return undefined;
  }
  return `DS-RankedRow DS-RankedRow-Rank-${rank}`;
};

export const getRowRankSelector = (rank: number): string => {
  return `.${getRowRankClass(rank)?.split(' ').join('.')}`;
};

export const getRankedTableSx = (
  theme: Theme,
  palette: string[]
): CSSObject => ({
  '.DS-RankedRow': rankVariables.reduce((acc, rankVar, rankIndex) => {
    acc[rankVar] = getThemeColor(theme, palette[rankIndex]);
    return acc;
  }, {} as CSSObject),
});
